// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingPage_loadingContainer__PaIZg","logo":"LoadingPage_logo__9teEn"};